<template>
    <div class="message-wrap" v-if="isActive">
        <div class="message-contain">
            <div class="message-cnt">
                <div class="box-head">
                    <span class="icon eqf-no" @click="onConfirm"></span>
                    <img v-if="params.type === 'success'" class="action" src="./sucess@2x.png" width="160px" alt="">
                    <img v-if="params.type === 'error'" class="action" src="./error@2x.png" width="160px" alt="">
                    <img v-if="params.type === 'received'" class="action" src="./received.png" width="160px" alt="">
                </div>
                <div class="box-content">
                    <p class="header">{{params.title}}</p>
                    <!-- <div class="qrcode">
                        <p>-- 更多福利，扫码领取 --</p>
                        <img src="./qrcode@2x.png" width="130px" alt="">
                    </div> -->
                </div>
                <div class="box-foot">确定</div>
            </div>

        </div>
        <div class="mask"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            params: {
                type: '',
                title: ''
            },
            isActive: false
        }
    },
    methods: {
        init(params) {
            this.params = Object.assign({}, this.params, params)
            this.isActive = true
        },

        onConfirm() {
            this.isActive = false
        }
    }
}
</script>
<style scoped lang="scss">
    .message-wrap{
        text-align: left;
        .mask{
            background-color: rgba(0,0,0,0.6);
            z-index: 2009;
        }
        .message-contain{
            z-index: 2010;
            .message-cnt{
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                padding: 28px;
                box-sizing: border-box;
                .box-head{
                    .icon{
                        position: absolute;
                        right: 0;
                        width: 36px;
                        height: 36px;
                        background-color: #6f6f6f;
                        border-radius: 18px;
                        text-align: center;
                        line-height: 36px;
                        color: #fff;
                        top: -10px;
                        right: -10px;
                        font-size: 18px;
                        cursor: pointer;
                        &:hover{
                            background-color: #818181;
                        }
                    }
                }
                .action{
                    position: absolute;
                    top: -24px;
                    left: 50%;
                    margin-left: -80px;
                }
                .box-content{
                    .header{
                        color: #fff;
                        font-size: 14px;
                        padding: 40px 25px 0;
                        font-weight: 600;
                        line-height: 18px;
                        height: 80px;
                    }
                    background-image: url(./bg@2x.png);
                    background-size: cover;
                    width: 280px;
                    height: 90px;
                    text-align: center;
                    .qrcode{
                        margin-top: 35px;
                        img{
                            margin-top: 15px;
                        }
                    }
                }
            }
        }
        .mask, .message-contain{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }
</style>
